import React, { useState, useEffect, useRef } from "react";
// import DatePicker from "react-datepicker";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { Form } from "react-bootstrap";

dayjs.extend(customParseFormat);


const BE_OFFSET = 543;

function formatDisplay(value) {
  const clean = value.replace(/\D/g, "").slice(0, 8);
  let result = "";

  if (clean.length > 0) result += clean.substring(0, 2);
  if (clean.length >= 3) result += "/" + clean.substring(2, 4);
  if (clean.length >= 5) result += "/" + clean.substring(4, 8);

  return result;
}

export function isValidDOB(value) {
  if (!value || value.length !== 10) return false;

  const [d, m, y] = value.split("/");
  const ceYear = parseInt(y, 10) - BE_OFFSET;

  const date = dayjs(
    `${ceYear}-${m}-${d}`,
    "YYYY-MM-DD",
    true
  );

  return date.isValid();
}

export default function BirthdayField({
  value,
  onChange,
  onBlur,
  error
}) {
  const [display, setDisplay] = useState("");
  const [date, setDate] = useState(null);
  const inputRef = useRef();

  useEffect(() => {
    setDisplay(value || "");

    if (value && value.length === 10) {
      const [d, m, y] = value.split("/");
      const ceYear = parseInt(y) - BE_OFFSET;
      const parsed = dayjs(`${ceYear}-${m}-${d}`);

      if (parsed.isValid()) {
        setDate(parsed.toDate());
      }
    }
  }, [value]);


  useEffect(() => {
    if (value !== display) {
      setDisplay(value || "");
    }
  }, [value]);


  const handleChange = (e) => {
    const input = e.target.value;
    const cursor = e.target.selectionStart;

    const digits = input.replace(/\D/g, "").slice(0, 8);

    let digitIndex = 0;
    for (let i = 0; i < cursor; i++) {
      if (/\d/.test(input[i])) digitIndex++;
    }

    const formatted = formatDisplay(digits);

    setDisplay(formatted);
    onChange({ target: { value: formatted } });

    let newPos = 0;
    let count = 0;

    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        count++;
      }

      if (count === digitIndex) {
        newPos = i + 1;
        break;
      }
    }

    if (digitIndex === 0) {
      newPos = 0;
    } else if (count < digitIndex) {
      newPos = formatted.length;
    }

    while (formatted[newPos] === "/") {
      newPos++;
    }

    while (formatted[newPos - 1] === "/") {
      newPos++;
    }

    newPos = Math.min(newPos, formatted.length);

    requestAnimationFrame(() => {
      inputRef.current.setSelectionRange(newPos, newPos);
    });
  };

  



  const handlePick = (selected) => {
    if (!selected) return;

    const be = dayjs(selected).add(BE_OFFSET, "year");
    const formatted = be.format("DD/MM/YYYY");

    setDate(selected);
    setDisplay(formatted);
    onChange({ target: { value: formatted } });
  };

  return (
    <Form.Control
      ref={inputRef}
      value={display}
      placeholder="วัน/เดือน/ปี (พ.ศ.)"
      onChange={handleChange}
      onBlur={onBlur}
      className={error ? "error-tips" : ""}
    />
  );
}